<template>
  <div class="container">
    <div class="ui grid">
      <h1>Gobal Settings</h1>
    </div>

    <div class="ui divider"></div>

    <form class="ui form segment" @submit.prevent="settingsUpdate">
      <div class="ui grid stackable">
        <div class="row">
          <div class="eight wide column">
            <label>SendGrid API Key</label>
            <input
              type="text"
              name="sendGridKey"
              placeholder="Sendgrid Key"
              v-model="sendGridKey"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Azure Key</label>
            <input
              type="text"
              name="azureStorageKey"
              placeholder="Azure Key"
              v-model="azureStorageKey"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Google Maps API Key</label>
            <input
              type="text"
              name="googleKey"
              placeholder="Google Key"
              v-model="googleKey"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <div class="ui buttons">
              <button class="ui positive button">Save Settings</button>
              <div class="or"></div>
              <div class="ui light button" @click="$router.go(-1)">Cancel</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();

export default {
  name: "Settings",
  computed: {},
  components: {},
  data() {
    return {
      sendGridKey: "",
      azureStorageKey: "",
      googleKey: "",
      error: false,
    };
  },
  mounted() {
    this.settingsDetails();
  },
  methods: {
    settingsDetails() {
      apiService
        .getSettings()
        .then((request) => {
          this.settingsSuccessful(request);
        })
        .catch((err) => this.settingsFailed(err));
    },
    settingsSuccessful(request) {
      (this.sendGridKey = request.sendGridKey),
        (this.azureStorageKey = request.azureStorageKey),
        (this.googleKey = request.googleKey);
    },
    settingsFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    settingsUpdate() {
      apiService
        .updateSettings({
          sendGridKey: this.sendGridKey,
          azureStorageKey: this.azureKey,
          googleKey: this.googleKey,
        })
        .then((request) => {
          this.settingsSuccessful(request);
          this.$router.push("/admin/settings/index");
        })
        .catch((err) => this.settingsFailed(err));
    },
  },
};
</script>

<style module></style>
